<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import { TweenMax as Tween, Power1 } from 'gsap'
import Logo from './elements/logo'
import LangSwitcher from './elements/lang-switcher'
import Burger from './elements/burger'

export default {

  name: 'TheHeader',

  components: {
    Logo,
    LangSwitcher,
    Burger
  },

  computed: {
    isDesktop () {
      return this.$store.getters['window'].width > 1023
    },

    isMobile () {
      return this.$store.getters['window'].width > 768
    },

    isHomepage () {
      return !!(this.$route.name && this.$route.name.match(/home/))
    },

    isInner () {
      return !!(this.$route.name && this.$route.name.match(/project$|story$|error/))
    },

    pageName () {
      if (!this.$route.name || this.$route.name.match(/error|not-found/)) return null

      if (this.$route.name.match(/project$|story$/)) {
        return this.$store.state.pages.inners[this.$route.params.slug].name
      }

      return this.$store.state.pages.landings[this.$route.name].name
    },

    state () {
      if (this.isPopupOpened) return 'is-default'

      const isShort = this.$route.name &&
        (!!this.$route.name.match(/about/) ||
        (!!this.$route.name.match(/home/) && this.$store.state.app.mainPageIntroSlide))

      return isShort ? 'is-short' : 'is-default'
    },

    isPopupOpened () {
      return this.$store.getters.isPopupOpened
    },

    isLoading () {
      return this.$store.getters.isLoading
    },

    isLogoInverted () {
      if (this.state === 'is-fixed') return false

      if (this.isLoading) return false
      if (this.isPopupOpened) return true

//      if(this.$store.state.app.mainPageSecondSlide) return false

      if (this.$route.name &&
          this.$route.name.match(/home/) &&
          this.$store.state.app.mainPageLastSlide) {
        const { width, height } = this.$store.getters['window']

        if (width >= 768 && height < 770) return false
        if (width < 768 && height < 520) return false
      }

      if (this.$route.name && this.$route.name.match(/home|about/)) return true

      return false
    },

    isMenuInverted () {
      if (this.state === 'is-fixed') return false;

      if (this.isLoading) return false;
      if (this.isPopupOpened) return true;

//      if(this.$store.state.app.mainPageSecondSlide) return false

      if (this.$route.name &&
          this.$route.name.match(/home/) &&
          this.$store.state.app.mainPageLastSlide) {
        const { width, height } = this.$store.getters['window'];

        if (width >= 768 && height < 770) return false;
        if (width < 768 && height < 520) return false;
      }

      if (this.$route.name && this.$route.name.match(/home|about/)) return true;
      if (this.$route.name && this.$route.name.match(/contacts/) && this.$store.state.app.window.width > 1024) return true;

      return false
    }
  },

  methods: {
    enter (el, done) {
      Tween.from(el, 1, {
        autoAlpha: 0,
        ease: Power1.easeOut,
        onComplete: done
      })
    },

    leave (el, done) {
      Tween.to(el, 0.5, {
        autoAlpha: 0,
        ease: Power1.easeOut,
        onComplete: done
      })
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

transition(name="header")
  header.header(:class="[[state], { 'header--fixed': isHomepage }]")
    .header__wrapper

      .header__column
        logo(:mode="isLogoInverted ? 'white' : 'black'")
        transition(name="page-name" mode="out-in")
          .page-name(
            v-if="!isLoading && !isHomepage && !isPopupOpened && pageName && isMobile",
            :key="$route.path + '_' + $route.name",
            :class="{ 'is-inverted': isLogoInverted }")
            .page-name__sep
            .page-name__label {{ pageName }}

      .header__column(:class="{ 'is-inverted': isMenuInverted }")
        lang-switcher
        burger

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.header
  position absolute
  top 50px
  left 0
  width 100%
  display flex
  justify-content center
  align-items flex-start
  transition transform .75s
  &--fixed
    position: fixed
  +mobile()
    top 15px
    &.is-default
      top: 0
      padding-top: 15px
  &.is-short
    transition transform .75s 1s

    +above(1024px)
      transform translateY(58px) translateZ(0)

    +tablet()
      padding 0 69px

    +mobile()
      padding 0

    .about-page &
      transition transform .75s
    // top 108px

  &.is-fixed
    position fixed
    top 0
    height auto
    background-color white

  &__wrapper
    position relative
    display flex
    justify-content space-between
    align-items center
    width header-default-width
    transition width 1s .75s

    .is-short &
      width header-short-width
      transition width 1s 0s

      .about-page &
        transition width 1s

  &__column
    display flex
    color primary

    &.is-inverted
      color white

.page-name
  display flex
  justify-content center
  align-items center
  user-select none
  margin-left -17px

  &__sep
    width 2px
    height 13px
    background-color primary
    margin-left 16px
    margin-right 20px
    transform skew(-30deg)
    transition background-color .5s

    .page-name.is-inverted &
      background-color white

  &__label
    font-weight 500
    font-size 14px
    text-transform uppercase
    transition color .5s

    .page-name.is-inverted &
      color white

// ===========================================
// Animations
// ===========================================

.header.is-fixed
  &.header-enter-active
    transition transform .4s
  &.header-enter
    transform translateY(-60px) translateZ(0)

  &.header-leave-active
    transition transform .3s, opacity .2s .3s, visibility .2s .3s
  &.header-leave-to
    transform translateY(-120px) translateZ(0)
    opacity 0
    visibility hidden

.header:not(.is-fixed)
  &.header-enter-active
    transition opacity .4s, visibility .4s
  &.header-enter
    opacity .4
    visibility hidden

.page-name-enter
.page-name-leave-to
  opacity 0
  visibility hidden
  transform translateX(-10px)

.page-name-enter-active
  transition opacity .4s, visiblity .4s, transform .4s

.page-name-leave-active
  transition opacity 0s, visiblity 0s, transform 0s

</style>



// WEBPACK FOOTER //
// the-header.vue?341e7240